/**
 * use in head()
 * @param {import('vue-i18n-routing').I18nHeadMetaInfo} i18nHead
 */
export function getI18nSEO(i18nHead) {
  /**
   * 雖然您可以將 x-default 值用於任何網頁，但這個值是專為語言選取器網頁所設計，因此最適合搭配這些網頁使用。
   * https://developers.google.com/search/docs/specialty/international/localized-versions?hl=zh-tw#xdefault
   */
  i18nHead.link = i18nHead.link.filter(linkItem => linkItem?.hreflang !== 'x-default')

  return i18nHead
}
